<template>
<div>
  <vx-card class="mb-8">
    <vs-row class=" w-ful mb-4 py-2">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>검색분석방법</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-radio class="mr-10" v-model="accessor_time" vs-value="accessor_time:1">오늘</vs-radio>
          <vs-radio class="mr-10" v-model="accessor_time" vs-value="accessor_time:2">시간대 별</vs-radio>
          <vs-radio class="mr-10" v-model="accessor_time" vs-value="accessor_time:3">일 별</vs-radio>
          <vs-radio class="mr-10" v-model="accessor_time" vs-value="accessor_time:4">월 별</vs-radio>
          <vs-radio class="mr-10" v-model="accessor_time" vs-value="accessor_time:5">년도 별</vs-radio>
        </vs-col>
      </vs-col>
    </vs-row>
    <vs-row class=" w-full mb-4">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>검색기간</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <date-selector></date-selector>
          <span class="mx-4">~</span>
          <date-selector></date-selector>
          <vs-button class="ml-auto w-2/12" color="secondary" >검색</vs-button>
        </vs-col>
      </vs-col>

    </vs-row>
  </vx-card>

  <vx-card class="line-card mb-8" noShadow cardBorder>
    <vs-row class="w-full text-center py-6">
      <vs-col class="w-2/12"> 총 접속자수 </vs-col>
      <vs-col class="w-2/12"> 평균 접속자수 </vs-col>
      <vs-col class="w-2/12"> 오늘 </vs-col>
      <vs-col class="w-2/12"> 어제 </vs-col>
      <vs-col class="w-2/12"> 이번달 </vs-col>
      <vs-col class="w-2/12"> 이번달 평균 </vs-col>
    </vs-row>
    <vs-row class="w-full text-center py-6">
      <vs-col class="w-2/12"> 23 </vs-col>
      <vs-col class="w-2/12"> 1,353 </vs-col>
      <vs-col class="w-2/12"> 0 </vs-col>
      <vs-col class="w-2/12"> 0 </vs-col>
      <vs-col class="w-2/12"> 2 </vs-col>
      <vs-col class="w-2/12"> 1,353 </vs-col>
    </vs-row>
  </vx-card>

  <vx-card class="">
    <vue-apex-charts type="line" height="350" :options="lineChartSimple.chartOptions" :series="lineChartSimple.series"></vue-apex-charts>
  </vx-card>
</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import DateSelector from '@/views/components/DateSelector'

export default {
  name: 'Accessor',
  components: {
    DateSelector,
    VueApexCharts
  },

  data () {

    return {
      accessor_time:'accessor_time:1',
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
      lineChartSimple: {
        series: [
          {
            name: 'Desktops',
            data: [
              33, 81, 61, 32, 52, 42, 80, 73, 89, 77, 66, 37,
              84, 38, 99, 68, 21, 79, 25, 69, 72, 64, 57, 56
            ]
          }
        ],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: this.themeColors,
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth' //'straight', 'smooth'
          },
          title: {
            text: '오늘 (2020.09.09) 시간대별 통계',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            categories: [
              '00시', '01시', '02시', '03시', '04시', '05시', '06시', '07시', '08시', '09시', '10시', '11시',
              '12시', '13시', '14시', '15시', '16시', '17시', '18시', '19시', '20시', '21시', '22시', '23시'
            ]
          }
        }
      }
    }

  }
}
</script>

<style>
.line-card .vx-card__collapsible-content .vx-card__body { padding: 0; }
.line-card .vs-row:first-child { background-color: #fff; font-weight: bold; border-top-left-radius: 1rem; border-top-right-radius: 1rem;}
.line-card .vs-row:last-child { background-color: #F9F9F9; border-bottom-left-radius: 1rem; border-bottom-right-radius: 1rem;}
</style>


<style scoped>
.fix-title { width:180px !important; }
.btn-icon { width:1.5rem; height:1.5rem;}

</style>
